<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M42 4H6a2 2 0 00-2 2v4a2 2 0 002 2h1v30a2 2 0 002 2h30a2 2 0 002-2V12h1a2 2 0 002-2V6a2 2 0 00-2-2zM10 30v-2h28v2zm0-6h28v2H10zm28-2H10v-2h28zm0-4H10v-2h28zM10 32h12.5v9H10zm15.5 9v-9H38v9zM38 14H10v-2h28zm3-5H7V7h34z"/></svg>